module.exports = __webpack_public_path__ + "img/abl_name.d9871650.png";